import {
  faCheckCircle,
  faTimesCircle,
  faUserCircle
} from '@fortawesome/pro-duotone-svg-icons'
import { useTranslation } from 'react-i18next'

import brandConfig from 'brandConfig'
import customConfig from 'customConfig'
import { COLOR_ERROR, COLOR_SUCCESS } from 'src/constants/theme'
import { ERROR_TEXT, MESSAGE_TEXT } from '../../../constants/messages'
import {
  isResendSignupVerifyFailed,
  isResendSignupVerifySuccess
} from '../../../util/auth.helpers'
import Popup from '../../shared/popup/Popup'
import Text from '../../shared/text/Text'
import TextLink from '../../shared/text/TextLink'

const SignupConfirmation = ({
  title,
  desc,
  onCancel,
  signupState,
  onResendVerification,
  isError = false,
  showResend,
  t
}) => (
  <Popup
    title={title}
    description={desc}
    icon={isError ? faTimesCircle : faCheckCircle}
    color={isError ? COLOR_ERROR : COLOR_SUCCESS}
    cancelLabel={t('common.close')}
    onCancel={onCancel}
  >
    {showResend && (
      <TextLink
        label={t(customConfig.resendVerificationEmailLabel)}
        onClick={onResendVerification}
      />
    )}
    {isResendSignupVerifySuccess(signupState) && (
      <Text label={t(MESSAGE_TEXT.VERIFICATION_EMAIL_SENT)} color='inherit' />
    )}
    {isResendSignupVerifyFailed(signupState) && (
      <Text
        label={t(ERROR_TEXT.RESEND_EMAIL_VERIFICATION_FAILED)}
        color={COLOR_ERROR}
      />
    )}
  </Popup>
)

const SignupVerificationSuccess = ({ onSubmit, t }) => (
  <Popup
    title={t(customConfig.youAreVerifiedLabel)}
    description={t(customConfig.youSuccessfullyVerifiedLabel)}
    icon={faUserCircle}
    submitLabel={t('login.log-in')}
    color={COLOR_SUCCESS}
    onFormSubmit={onSubmit}
  />
)

const TermsNotAccepted = ({
  onAcceptTermsSubmit,
  onCancelTerms,
  children,
  t
}) => {
  return (
    <Popup
      title={t(customConfig.termsAcceptPageTitle)}
      description={t(customConfig.carefullyReadTermsLabel)}
      submitLabel={t('sign-up.sign-up')}
      onFormSubmit={onAcceptTermsSubmit}
      cancelLabel={t('common.back')}
      onCancel={onCancelTerms}
    >
      {children}
    </Popup>
  )
}

const EmailMissing = ({ onSubmit, onCancel }) => {
  const { t } = useTranslation()
  return (
    <Popup
      title={t('missing-email.missing-email')}
      description={t('missing-email.need-email-to-send-points', {
        brand: brandConfig.fbAppName
      })}
      icon={faTimesCircle}
      color={COLOR_ERROR}
      submitLabel={t('missing-email.share-email')}
      onFormSubmit={onSubmit}
      cancelLabel={t('common.close')}
      onCancel={onCancel}
    />
  )
}

export {
  EmailMissing,
  SignupConfirmation,
  SignupVerificationSuccess,
  TermsNotAccepted
}
